/* eslint-disable react/jsx-boolean-value */
import { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import useWindowSize from '../../../../hooks/useWindowSize';
import { getBusinessDashboardTotalUsersCountry } from '../../../../services/Service';

const CustomersCountryWise = () => {
  const { width } = useWindowSize();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  //   const [mode, setMode] = useState('CurrentMonth'); // CurrentMonth, LastMonth, Names

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await getBusinessDashboardTotalUsersCountry();
      setData(res.data.data);
      setTotal(res.data.total);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const chartOption = {
    title: {
      text: 'Customers Country Wise',
      left: 'left', // Align title to the left
      textStyle: {
        color: '#468b47', // Green color for the title
        lineHeight: 16, // Reduced line height
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)', // Tooltip shows name, value, and percentage
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      left: 'right', // Position legend to the right
      top: 'center', // Vertically center the legend
      formatter: (name) => {
        const data = chartOption.series[0].data;
        const total = data.reduce((sum, item) => sum + item.value, 0);
        const item = data.find((d) => d.name === name);
        const percentage = ((item.value / total) * 100).toFixed(2); // Calculate percentage

        return `${name} (${percentage}%)`; // Display name with percentage
      },
    },
    series: [
      {
        name: 'Customers Country Wise',
        type: 'pie',
        radius: width > 1400 ? '75%' : '50%',
        center: ['40%', '50%'], // Move the pie chart to the left
        data: data?.map((e) => ({
          value: e.count,
          name: e.country,
        })),
        itemStyle: {
          color: (params) => {
            const colors = ['#468b47', '#90ee90', '#edf9eb', '#385239'];
            return colors[params.dataIndex % colors.length]; // Apply custom colors
          },
        },
      },
    ],
  };

  return (
    <div
      style={{
        padding: '12px',
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      {/* <select style={{ position: 'absolute', right: '12px', top: '12px',zIndex:1 }}>
        <option value="option 1">option 1</option>
        <option value="option 2">option 2</option>
        <option value="option 3">option 3</option>
      </select> */}
      <ReactECharts
        notMerge={true}
        lazyUpdate={true}
        showLoading={loading}
        option={chartOption}
        style={{ height: '400px', minHeight: '300px' }}
      />
    </div>
  );
};
export default CustomersCountryWise;
